import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import StoreContext from "./../../../Store/Context";
import styled from "styled-components";
import { Row, Col, Button } from "reactstrap";
import { Announcement, ProfilePanel,validateTokenStorage } from "../../Constants/Util";
import { ChangePassword, ChangeEmail, ChangeAvatar } from "./../../Constants/Modal";
import { IStudentProfile, IStudentAnnouncement, IAcudProfile } from "./../../Constants/Interfaces";
import {
  getProfile,
  getProfileAcu,
  getAnnouncement,
  putEmail,
  putStudentPassword,
  urlHttpPostAvatar,
  validateLogin,
} from "./../../Constants/Services";

interface IHomeState {
  isOpenModalPassword: boolean;
  isOpenModalEmail: boolean;
  isOpenModalAvatar: boolean;
  dataProfileStudent: IStudentProfile;
  dataProfileAcud: IAcudProfile;
  dataAnnouncement: IStudentAnnouncement[];
  loading: boolean;
  emailChanged: string;
  formPassword: {
    per_password: string;
    per_password_again: string;
  };
  formEmail: {
    per_email: string;
  };
  msg_error: string;
  std_img: string;
  acu_img: string;
  t_person: string;
}

const StyledDivAnnouncement = styled.div`
  margin-bottom: 40px;
  overflow: scroll;
  overflow-x: hidden;
  height: 45vh;
  padding: 10px;
`;

class Home extends Component<RouteComponentProps<{}>, IHomeState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      isOpenModalPassword: false,
      isOpenModalEmail: false,
      isOpenModalAvatar: false,
      loading: false,
      emailChanged: "",
      dataProfileStudent: {
        per_id: "",
        per_name: "",
        per_lastname: "",
        per_cedula: "",
        per_email: "",
        gr_desc: "",
        per_password: "",
      },
      dataProfileAcud: {
        per_id: "",
        per_name: "",
        per_lastname: "",
        per_cedula: "",
        per_celphones: "",
      },
      formPassword: {
        per_password: "",
        per_password_again: "",
      },
      formEmail: {
        per_email: "",
      },
      dataAnnouncement: [],
      msg_error: "",
      acu_img: "",
      std_img: "",
      t_person: "",
    };
    this.fetchValidateLogin = this.fetchValidateLogin.bind(this);
    this.handleModalPassword = this.handleModalPassword.bind(this);
    this.handleModalEmail = this.handleModalEmail.bind(this);
    this.handleModalAvatar = this.handleModalAvatar.bind(this);
    this.handleCloseModalAvatar = this.handleCloseModalAvatar.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.handlerPutEmail = this.handlerPutEmail.bind(this);
    this.handlerPutPassword = this.handlerPutPassword.bind(this);
    this.emailCloseAvatar = this.emailCloseAvatar.bind(this);
  }

  async fetchValidateLogin() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      const response = await validateLogin(this.context.per_id, this.context.usr_type.replace(/\//g, ""));
      if (response.inactivo) {
        this.context.quitToken();
      }
    }
    else{
      const response = await validateLogin(this.context.per_id, this.context.usr_type.replace(/\//g, ""));
      if (response.inactivo) {
        this.context.quitToken();
      }
    }
  }

  async fetchStudentProfile() {
    var response;
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      response = await getProfileAcu(this.context.per_id, this.context.per_std);
    } else {
      response = await getProfile(this.context.per_id, this.context.usr_type.replace(/\//g, ""));
    }
    if(response.acud[0] === undefined){
      this.setState({
        dataProfileStudent: response.student[0],
        dataProfileAcud: {
          per_id: "",
          per_name: "",
          per_lastname: "",
          per_cedula: "",
          per_celphones: "",
        },
        acu_img: response.acu_img,
        std_img: response.std_img,
        loading: true,
      });
    }
    else{
      this.setState({
        dataProfileStudent: response.student[0],
        dataProfileAcud: response.acud[0],
        acu_img: response.acu_img,
        std_img: response.std_img,
        loading: true,
      });
    }
    setTimeout(() => {
      this.setState({
        loading: false,
      });
    }, 1000);
  }

  async fetchStudentAnnouncement() {
    const response = await getAnnouncement();
    this.setState({ dataAnnouncement: response, loading: false });
  }

  componentDidMount() {
    this.fetchStudentProfile();
    this.fetchStudentAnnouncement();
    this.fetchValidateLogin();
  }

  handleModalPassword() {
    this.setState((prevState) => ({
      isOpenModalPassword: !prevState.isOpenModalPassword,
      formPassword: {
        per_password: "",
        per_password_again: "",
      },
    }));
  }

  handleModalEmail() {
    if (this.context.usr_type.replace(/\//g, "") === "student") {
      this.setState((prevState) => ({
        isOpenModalEmail: !prevState.isOpenModalEmail,
        emailChanged: "",
        msg_error: "",
        formEmail: {
          per_email: "",
        },
      }));
    }
  }

  handleCloseModalAvatar() {
    this.setState((prevState) => ({
      isOpenModalAvatar: !prevState.isOpenModalAvatar,
    }));
    setTimeout(() => {
      this.fetchStudentProfile();
    }, 1000);
  }

  handleModalAvatar(t_person: string) {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    if (this.context.usr_type.replace(/\//g, "") === "student") {
      if (t_person === "STD") {
        this.setState((prevState) => ({
          isOpenModalAvatar: !prevState.isOpenModalAvatar,
          t_person,
        }));
        setTimeout(() => {
          this.fetchStudentProfile();
        }, 1000);
      }
    } else {
      if (t_person === "ACU") {
        this.setState((prevState) => ({
          isOpenModalAvatar: !prevState.isOpenModalAvatar,
          t_person,
        }));
        setTimeout(() => {
          this.fetchStudentProfile();
        }, 1000);
      }
    }
  }

  handlerPutEmail() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    const props = this.state;
    if (props.formEmail.per_email.length > 12) {
      const body = {
        per_id: props.dataProfileStudent.per_id,
        per_email: props.formEmail.per_email,
      };
      putEmail(body);
      this.setState({
        isOpenModalPassword: false,
        isOpenModalAvatar: false,
        isOpenModalEmail: false,
        loading: false,
      });
      setTimeout(() => {
        this.fetchStudentProfile();
      }, 1000);
    } else {
      this.setState({
        msg_error: "Escribe un correo valido",
      });
    }
  }

  handlerPutPassword() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    const props = this.state;
    const body = {
      per_id: props.dataProfileStudent.per_id,
      per_password: props.formPassword.per_password,
    };
    putStudentPassword(body);
    this.setState({
      isOpenModalPassword: false,
      isOpenModalAvatar: false,
      isOpenModalEmail: false,
      loading: false,
    });
    setTimeout(() => {
      this.fetchStudentProfile();
    }, 1000);
  }

  onChangePassword(e: any) {
    this.setState({
      formPassword: {
        ...this.state.formPassword,
        [e.target.name]: e.target.value,
      },
    });
  }

  emailCloseAvatar() {
    this.setState((prevState) => ({
      isOpenModalPassword: !prevState.isOpenModalPassword,
    }));
  }

  onChangeEmail(e: any) {
    this.setState({
      formEmail: {
        ...this.state.formEmail,
        [e.target.name]: e.target.value,
      },
    });
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalPassword && (
          <ChangePassword
            password={props.dataProfileStudent.per_password}
            isOpen={props.isOpenModalPassword}
            toggle={this.handleModalPassword}
            toggleSave={this.handlerPutPassword}
            onChange={this.onChangePassword}
          />
        )}
        {props.isOpenModalEmail && (
          <ChangeEmail
            email={props.dataProfileStudent.per_email}
            isOpen={props.isOpenModalEmail}
            toggle={this.handleModalEmail}
            toggleSave={this.handlerPutEmail}
            onChange={this.onChangeEmail}
            data={props.dataProfileStudent}
            msg_error={props.msg_error}
          />
        )}
        {props.isOpenModalAvatar && (
          <ChangeAvatar
            isOpen={props.isOpenModalAvatar}
            toggle={this.handleCloseModalAvatar}
            IMG_AVATAR={props.t_person === "STD" ? props.std_img : props.acu_img}
            nameImg={props.t_person === "STD" ? props.dataProfileStudent.per_id : props.dataProfileAcud.per_id}
            urlHttp={urlHttpPostAvatar}
          />
        )}
        <Row className="">
          <Col sm={12} className="text-center">
            {this.context.usr_type.replace(/\//g, "") === "student" ? (
              <h4 className="font-weight-bold">Perfil del estudiante</h4>
            ) : (
              <h4 className="font-weight-bold">Perfil del acudiente</h4>
            )}
          </Col>
          <Col sm={12} className="text-right mt-4">
            <Button className="info" onClick={() => this.handleModalPassword()}>
              Cambiar contraseña
            </Button>
          </Col>
          <Col sm={12} className="mt-4">
            <ProfilePanel
              propsStdudent={props.dataProfileStudent}
              propsAcud={props.dataProfileAcud}
              handleModalEmail={this.handleModalEmail}
              handleModalAvatar={this.handleModalAvatar}
              ACU_AVATAR={props.acu_img}
              STD_AVATAR={props.std_img}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={3}></Col>
          <Col sm={12} className="text-center mt-4">
            <h4 className="font-weight-bold">Muro de anuncios</h4>
          </Col>
          <Col sm={12} className="text-center">
            <StyledDivAnnouncement>
              {props.dataAnnouncement.map((item: any, i: any) => (
                <Announcement key={i} data={item} />
              ))}
            </StyledDivAnnouncement>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
export default Home;
